import React from "react";
import { Link as RouterLink } from "react-router-dom";
import {
  Container, VStack, Heading, Text, Box, Badge, HStack,
  Divider, Button, Link,
} from "@chakra-ui/react";
import { FiArrowLeft } from "react-icons/fi";
import { NavbarWithCallToAction } from "../../components/chakra/NavbarWithCallToAction/NavbarWithCallToAction";
import { FooterWithFourColumns } from "../../components/chakra/FooterWithFourColumns/FooterWithFourColumns";
import { getColor } from "../../brandConfig";

const MarchVideoUpdate: React.FC = () => (
  <Box bg={getColor("background.main")} minHeight="100vh" display="flex" flexDirection="column">
    <NavbarWithCallToAction />

    <Container maxW="container.md" py={10} flex="1">
      <VStack spacing={6} align="stretch">
        {/* Back link */}
        <Link as={RouterLink} to="/updates" _hover={{ textDecoration: "none" }}>
          <Button variant="ghost" size="sm" leftIcon={<FiArrowLeft />} color={getColor("text.muted")}>
            All Updates
          </Button>
        </Link>

        {/* Header */}
        <VStack spacing={3} align="start">
          <HStack>
            <Badge colorScheme="blue">Video Update</Badge>
            <Text fontSize="xs" color={getColor("text.muted")}>23 March 2026</Text>
          </HStack>
          <Heading size="lg" color={getColor("text.primary")}>
            SurgReady Platform Walkthrough
          </Heading>
          <Text color={getColor("text.secondary")}>
            Full demo of the SurgReady patient journey — from sign-up and payment through to course access and health assessment.
          </Text>
        </VStack>

        <Divider />

        {/* Video */}
        <Box
          borderRadius="xl"
          overflow="hidden"
          border="1px"
          borderColor={getColor("border.light")}
          bg="black"
        >
          <video
            controls
            width="100%"
            style={{ display: "block" }}
          >
            <source src="https://files.tommillerservices.com/ipfs/QmWonAevG7dg6BdMVrwECLkhQjbjjEiZ1DcAst6a3NKfU9" type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </Box>

        <Divider />

        {/* What's covered */}
        <Box>
          <Heading size="md" color={getColor("text.primary")} mb={3}>What's Covered</Heading>
          <VStack align="start" spacing={2}>
            <Text color={getColor("text.secondary")} fontSize="sm">1. Patient sign-up and account creation</Text>
            <Text color={getColor("text.secondary")} fontSize="sm">2. One-off payment with card saved on file</Text>
            <Text color={getColor("text.secondary")} fontSize="sm">3. Automatic course enrollment and permission grants</Text>
            <Text color={getColor("text.secondary")} fontSize="sm">4. 12-module surgical preparation course access</Text>
            <Text color={getColor("text.secondary")} fontSize="sm">5. Health assessment with readiness scoring</Text>
            <Text color={getColor("text.secondary")} fontSize="sm">6. Admin tools: client management, notifications, billing</Text>
          </VStack>
        </Box>

        <Divider />

        {/* Course Content Editing Video */}
        <Box>
          <Heading size="md" color={getColor("text.primary")} mb={2}>How to Edit Course Content</Heading>
          <Text color={getColor("text.secondary")} fontSize="sm" mb={4}>
            This video shows you how to edit the content of your courses — add lessons, update text, upload images, and manage modules.
          </Text>
          <Box
            borderRadius="xl"
            overflow="hidden"
            border="1px"
            borderColor={getColor("border.light")}
            bg="black"
          >
            <video
              controls
              width="100%"
              style={{ display: "block" }}
            >
              <source src="https://files.tommillerservices.com/ipfs/QmVV6YNAwkJsBaMYEDEtigme1bgQcr4pfdHyYmRJXqfMuD" type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </Box>
        </Box>

        <Divider />

        {/* Related Links */}
        <Box>
          <Heading size="md" color={getColor("text.primary")} mb={3}>Related</Heading>
          <VStack align="start" spacing={2}>
            <Link as={RouterLink} to="/cheatsheets/surgready-patient-journey" color={getColor("primary")} fontSize="sm">
              Patient Journey Diagram & Site Map
            </Link>
            <Link as={RouterLink} to="/cheatsheets/surgready-assessment-module" color={getColor("primary")} fontSize="sm">
              Assessment Module Architecture
            </Link>
            <Link as={RouterLink} to="/subscribe/getting-started" color={getColor("primary")} fontSize="sm">
              Subscribe Page (Patient View)
            </Link>
          </VStack>
        </Box>

        {/* Sign off */}
        <Box pt={4}>
          <Text color={getColor("text.secondary")}>Regards,</Text>
          <Text color={getColor("text.primary")} fontWeight="bold" mt={1}>Dr Thomas Miller</Text>
          <Text color={getColor("text.muted")} fontSize="sm" fontStyle="italic">Tom Miller Services</Text>
        </Box>
      </VStack>
    </Container>

    <FooterWithFourColumns />
  </Box>
);

export default MarchVideoUpdate;
